module.exports = __webpack_public_path__ + "media/G1.94465ca8.mp3";